module.exports = __webpack_public_path__ + "img/bundelselect.c832fc8e.png";